import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../shared/table/table.component';

@Component({
  selector: 'app-evaluaciones-estudiante',
  standalone: true,
  imports: [TableComponent, FormsModule],
  templateUrl: './evaluaciones-estudiante.component.html',
  styleUrl: './evaluaciones-estudiante.component.css'
})
export class EvaluacionesEstudianteComponent {
  evaluaciones: any[] = [];
  columns: { key: string; label: string }[] = [
    { key: 'nombre', label: 'Nombre' },
    { key: 'duracion', label: 'Duración(mins)' },
    { key: 'fecha_fin', label: 'Fecha de Fin' },

  ];
  actions = [
    {
      class: 'bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded',
      icon: 'fas fa-pen',
      tooltip: 'Listar',
      callback: (item: any) =>{
        //console.log('Editar:', item.id_evaluacion),
        //pregunta si esta seguro de editar
        this.router.navigate(['/evaluacion-estudiante'], { queryParams: { id_evaluacion: item.id_evaluacion } })}
    }
  ];
  constructor(private http: HttpClient, private router: Router) {}
  ngOnInit() {
    //console.log(JSON.parse(localStorage.getItem('user')!).id_rol_usuario)
    this.obtenerDatos();
  }

  obtenerDatos() {
    this.http.get<any[]>(`${environment.apiUrl}/evaluacion?id_rol_usuario=${JSON.parse(localStorage.getItem('user')!).id_rol_usuario}`).subscribe(
      (data) => {
        this.evaluaciones = data;
      },
      (error) => {
        console.error('Error al obtener los datos:', error);
      }
    );
  }
  volver(): void {
    this.router.navigate(['/main']);
  }
}
